// Generate .ics calendar files so players can add games to their phone calendar
// with built-in reminders (works on iOS Calendar, Google Calendar, Outlook).

function pad(n) {
  return String(n).padStart(2, "0");
}

function toIcsDate(date) {
  const d = new Date(date);
  return (
    d.getUTCFullYear() +
    pad(d.getUTCMonth() + 1) +
    pad(d.getUTCDate()) +
    "T" +
    pad(d.getUTCHours()) +
    pad(d.getUTCMinutes()) +
    pad(d.getUTCSeconds()) +
    "Z"
  );
}

function escapeIcs(text) {
  return String(text || "").replace(/([,;\\])/g, "\\$1").replace(/\n/g, "\\n");
}

function eventBlock(tournament, game, durationHours = 3) {
  if (!game.scheduled_at) return null;
  const start = new Date(game.scheduled_at);
  const end = new Date(start.getTime() + durationHours * 3600 * 1000);
  const uid = `${tournament.id}-${game.index}@vegas2027`;
  return [
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${toIcsDate(new Date())}`,
    `DTSTART:${toIcsDate(start)}`,
    `DTEND:${toIcsDate(end)}`,
    `SUMMARY:${escapeIcs(`${tournament.name} — ${game.name}`)}`,
    `DESCRIPTION:${escapeIcs(`${tournament.name} tournament game. Good luck!`)}`,
    // Reminder 1 day before
    "BEGIN:VALARM",
    "TRIGGER:-P1D",
    "ACTION:DISPLAY",
    `DESCRIPTION:${escapeIcs(`Tomorrow: ${tournament.name} — ${game.name}`)}`,
    "END:VALARM",
    // Reminder 2 hours before
    "BEGIN:VALARM",
    "TRIGGER:-PT2H",
    "ACTION:DISPLAY",
    `DESCRIPTION:${escapeIcs(`Starting soon: ${tournament.name} — ${game.name}`)}`,
    "END:VALARM",
    "END:VEVENT",
  ].join("\r\n");
}

function buildIcs(events) {
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Vegas 2027//Tournament Tracker//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    ...events,
    "END:VCALENDAR",
  ].join("\r\n");
}

function download(filename, content) {
  const blob = new Blob([content], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function addGameToCalendar(tournament, game) {
  const block = eventBlock(tournament, game);
  if (!block) return false;
  download(`${tournament.name}-game-${game.index + 1}.ics`, buildIcs([block]));
  return true;
}

export function addAllGamesToCalendar(tournament, games) {
  const blocks = games.map((g) => eventBlock(tournament, g)).filter(Boolean);
  if (blocks.length === 0) return false;
  download(`${tournament.name}-schedule.ics`, buildIcs(blocks));
  return true;
}
